import React from 'react';
import { Button } from 'antd';
import styles from './interaction_expiration_dialog.module.scss';

interface InteractionExpirationDialogProps {
  onContinue: () => void;
  onStartFromBeginning: () => void;
}

const InteractionExpirationDialog: React.FC<
  InteractionExpirationDialogProps
> = ({ onContinue, onStartFromBeginning }) => {
  return (
    <div
      data-cy="interaction_expiration"
      className={`${styles.dialogContainer} notranslate`}
      translate="no"
    >
      <div style={{ marginBottom: '12px', width: '100%' }}>
        <div style={{ position: 'relative', textAlign: 'center' }}>
          <div className={styles.dialogLine}></div>
          <div
            data-cy="interaction_expiration_text"
            className={`${styles.dialogText} notranslate`}
            translate="no"
          >
            <p className="notranslate" translate="no" style={{ fontSize: '16px', marginBottom: 0, marginTop: 0 }}>
              <span className="notranslate" translate="no">Session Timed Out</span>
            </p>
            <p className="notranslate" translate="no" style={{ fontSize: '12px', marginBottom: 0, marginTop: 0 }}>
              <span className="notranslate" translate="no">Previous responses can't be edited. To make changes, you'll need to start a new survey.</span>
            </p>
          </div>
        </div>
      </div>

      <div style={{ width: '100%', maxWidth: '450px', marginBottom: '12px' }}>
        <Button
          type="default"
          block
          onClick={onContinue}
          data-cy="interaction_expiration_continue_button"
          className={styles.actionButton}
        >
          <span className="notranslate" translate="no">Continue This Survey</span>
        </Button>
      </div>

      <div style={{ width: '100%', maxWidth: '450px' }}>
        <Button
          type="default"
          block
          onClick={onStartFromBeginning}
          data-cy="interaction_expiration_start_from_beginning_button"
          className={styles.actionButton}
        >
          <span className="notranslate" translate="no">Start a New Survey</span>
        </Button>
      </div>
    </div>
  );
};

export default InteractionExpirationDialog;
